module.exports = __webpack_public_path__ + "img/create_document.7fc4ce52.svg";